import { takeLatest, put, take } from 'redux-saga/effects';
import { ACTIONS } from '../actions/actionTypes';
import * as game from '../controllers';
import errorCatcher from '../utils/errorCatcher';

export function * ACCEPT_SESSION () {
    try {
        yield takeLatest(ACTIONS.ACCEPT_SESSION, function * (action) {
            yield put({type: ACTIONS.SET_QUESTION_LOADING, payload: true});
            const missionId = action.payload ? action.payload.id : '';
            yield put({type: ACTIONS.GET_QUESTIONS, payload: missionId});
            yield take(ACTIONS.SET_QUESTION_LOADING);
            yield put({type: ACTIONS.CLOSE_SIMPLE_MODAL});
            yield put({type: ACTIONS.START_SESSION, payload: action.payload});
        });
    } catch (error) {
        errorCatcher('Error in ACCEPT_SESSION (gameSaga)', error);
    }
}

export function * SAVE_SESSION () {
    yield takeLatest(ACTIONS.SAVE_SESSION, function * (action) {
        try {
            const {userMission, session} = action.payload;
            const result = yield game.session.add({params: userMission, body: session});
            console.log('SAVE_SESSION', result);
            yield put({type: ACTIONS.USER_UPDATE_LOCAL_DATA, payload: result.user});
            yield put({type: ACTIONS.USER_SET_WHATSNEXT, payload: result.whatsNext});
            yield put({type: ACTIONS.SET_SESSION, payload: result});
            yield put({type: ACTIONS.SET_QUESTION_LOADING, payload: false});
        } catch (err) {
            errorCatcher(err);
        }
    });
}



// WEBPACK FOOTER //
// ./src/sagas/sessionSaga.js